/* eslint-disable no-undef */
var initESW = function (gslbBaseURL) {
    embedded_svc.settings.displayHelpButton = false; //Or false
    embedded_svc.settings.language = language; //For example, enter 'en' or 'en-US'

    let emailLabel = 'Email';
    let firstNameLabel = 'First Name';
    let lastNameLabel = 'Last Name';

    // if language code is 'no' set emailLabel/firstNameLabel/lastNameLabel to match prechat localization, else default to English
    if (embedded_svc.settings.language === 'no') {
        emailLabel = 'E-post';
        firstNameLabel = 'Fornavn';
        lastNameLabel = 'Etternavn';
    }

    embedded_svc.settings.defaultMinimizedText = chatText; //'Library chat'; //(Defaults to Chat with an Expert)
    embedded_svc.settings.disabledMinimizedText = offlineText; //'Library chat offline'; //(Defaults to Agent Offline)

    chatParams = typeof chatParams === 'undefined' ? null : chatParams;

    embedded_svc.settings.prepopulatedPrechatFields = {
        FirstName: chatParams?.firstName,
        LastName: chatParams?.lastName,
        Email: chatParams?.email,
        Category_temp__c: chatParams?.category,
        Domain_Origin__c: 'Public website',
    };

    embedded_svc.settings.extraPrechatFormDetails = [
        { label: 'Status', value: 'In Progress', displayToAgent: false },
        {
            label: 'Domain origin',
            value: chatParams ? 'Application web' : 'Public website',
            transcriptFields: ['Domain_Origin__c'],
            displayToAgent: true,
        },
        {
            label: 'ContactId',
            value: chatParams?.contactId,
            transcriptFields: ['ContactId'],
            displayToAgent: false,
        },
    ];

    embedded_svc.settings.extraPrechatInfo = [
        {
            entityName: 'Contact',
            saveToTranscript: 'Contact',
            showOnCreate: true,
            entityFieldMaps: [
                {
                    doCreate: true,
                    doFind: false,
                    fieldName: 'LastName',
                    isExactMatch: false,
                    label: lastNameLabel,
                },
                {
                    doCreate: true,
                    doFind: false,
                    fieldName: 'FirstName',
                    isExactMatch: false,
                    label: firstNameLabel,
                },
                {
                    doCreate: true,
                    doFind: true,
                    fieldName: 'Email',
                    isExactMatch: true,
                    label: emailLabel,
                },
                {
                    isExactMatch: false,
                    fieldName: 'ContactId',
                    doCreate: true,
                    doFind: false,
                    label: 'ContactId',
                },
            ],
        },
    ];

    embedded_svc.settings.enabledFeatures = ['LiveAgent'];
    embedded_svc.settings.entryFeature = 'LiveAgent';
    const chatHandler = function () {
        try {
            embedded_svc.onHelpButtonClick();
        } catch (e) {
            console.log(e);
        } finally {
            clickDaButt();
        }
    };

    const els = document.getElementsByClassName('chat-button1');
    Array.prototype.forEach.call(els, function (el) {
        el.addEventListener('click', chatHandler);
    });

    embedded_svc.init(envUrl, chatType, gslbBaseURL, someNumber, chatName, {
        baseLiveAgentContentURL: baseLiveAgentContentUrl,
        deploymentId: deploymentId,
        buttonId: buttonId,
        baseLiveAgentURL: baseLiveAgentUrl,
        eswLiveAgentDevName: liveAgentDevName,
        isOfflineSupportEnabled: false,
    });
};

if (!window.embedded_svc) {
    var s = document.createElement('script');
    s.setAttribute('src', jsScriptEnv);
    s.onload = function () {
        initESW(null);
    };
    document.body.appendChild(s);
} else {
    initESW('https://service.force.com');
}
